module.exports = __webpack_public_path__ + "img/H3.12e95ed7.png";